/*
 * This helper wraps window.location methods to allow easy mocking in tests (JSDOM),
 * where window.location is read-only and cannot be directly spied on or reassigned.
 */

const assign = (url) => {
  window.location.assign(url);
};

const getPathname = () => {
  return window.location.pathname;
};

const getHref = () => {
  return window.location.href;
};

const getOrigin = () => {
  return window.location.origin;
};

const getHost = () => {
  return window.location.host;
};

export default {
  assign,
  getPathname,
  getHref,
  getOrigin,
  getHost
};
